module.exports = __webpack_public_path__ + "static/img/jp.b4dbf8d2.svg";